import axios from 'axios';

// API configured with environment variable
const baseURL = import.meta.env.VITE_BASE_URL;

// Default request (no auth token)
const getDefaultRequest = () => {
  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// Authenticated request (with auth token)
const getAuthRequest = (token) => {
  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
};

export default getDefaultRequest;
export { getAuthRequest };